

export function attachmentThumbnailDirective() {


  return {
    restrict: 'E',
    template: require('./attachment-thumbnail.directive.html'),
    scope: {
      companyId: '=',
      siteId: '=',
      attachment: '=', 
      onImgLoadFn: '&?onImgLoad'
    },
    controller: AttachmentThumbnailController,
    link: link
  }
}

AttachmentThumbnailController.$inject = ['$scope', 'MediasFactory'];
function AttachmentThumbnailController($scope, MediasFactory) {

  $scope.downloadAttachment = downloadAttachment;

  init();

  function init() {
    const thumbnail = {};
    const attachmentValue = $scope.attachment.value;
    if (attachmentValue.pictureId) {
      thumbnail.pictureUrl = MediasFactory.pictureUrl($scope.companyId, attachmentValue.pictureId);
    }
    if (attachmentValue.videoId) {
      thumbnail.videoUrl = MediasFactory.videoUrl($scope.companyId, attachmentValue.videoId);
    }
    if ($scope.attachment.type === 'file') {
      thumbnail.fileUrl = MediasFactory.fileUrl($scope.companyId, attachmentValue.fileId);
      thumbnail.fileName = attachmentValue.fileName;
    }
    thumbnail.title = attachmentValue.title;
    thumbnail.url = attachmentValue.url;
    thumbnail.type = $scope.attachment.type;
    $scope.thumbnail = thumbnail;
  }

  function downloadAttachment() {
    MediasFactory.downloadFile($scope.thumbnail.fileUrl, $scope.thumbnail.fileName);
  }
}

function link($scope, element) {
  if ($scope.onImgLoadFn && element.find('img').length > 0) {
    element.find('img').on('load', $scope.onImgLoadFn);
  }
}
